import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesDeliveryFees } from "../../constants";

export const requestUpdateDeliveryZoneStatus = async ({
  zoneId,
  isActive
}: {
  zoneId: string;
  isActive: boolean;
}): Promise<void> => {
  return await instance.patch(
    buildUrl(ApiRoutesDeliveryFees.DeliveryZone, zoneId),
    { isActive }
  );
};
